"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Coach = exports.Player = exports.CollegeSeasonGame = exports.CollegeSeason = exports.RcrtStaffChange = exports.CollegeRef = exports.Conference = exports.College = exports.supportedYears = exports.EScrapeStatus = exports.COLLEGE_GENDERS = exports.ERcrtScrapingErrors_MAP = exports.ERcrtClassYears = exports.ERosterMetricMap = exports.EMetricCategories = exports.ERcrtScrapingErrors = exports.allLinkTypes = exports.conferenceLinkTypes = exports.collegeLinkTypes = exports.eventLinkTypes = exports.LOCK_LEVELS = exports.COLLEGE_SUBDIVISIONS = exports.COLLEGE_DIVISIONS = void 0;
const model_core_1 = require("@nxt/model-core");
const index_1 = require("../index");
const date_fns_1 = require("date-fns");
var COLLEGE_DIVISIONS;
(function (COLLEGE_DIVISIONS) {
    COLLEGE_DIVISIONS["NCAA"] = "NCAA";
    COLLEGE_DIVISIONS["NAIA"] = "NAIA";
    COLLEGE_DIVISIONS["NCCAA"] = "NCCAA";
    COLLEGE_DIVISIONS["JUCO"] = "Junior College";
    COLLEGE_DIVISIONS["USCAA"] = "USCAA";
    COLLEGE_DIVISIONS["OTHER"] = "OTHER";
    COLLEGE_DIVISIONS["NONE"] = "";
})(COLLEGE_DIVISIONS || (exports.COLLEGE_DIVISIONS = COLLEGE_DIVISIONS = {}));
var COLLEGE_SUBDIVISIONS;
(function (COLLEGE_SUBDIVISIONS) {
    COLLEGE_SUBDIVISIONS["D1"] = "Division 1";
    COLLEGE_SUBDIVISIONS["D2"] = "Division 2";
    COLLEGE_SUBDIVISIONS["D3"] = "Division 3";
    COLLEGE_SUBDIVISIONS["NONE"] = "";
})(COLLEGE_SUBDIVISIONS || (exports.COLLEGE_SUBDIVISIONS = COLLEGE_SUBDIVISIONS = {}));
var LOCK_LEVELS;
(function (LOCK_LEVELS) {
    LOCK_LEVELS[LOCK_LEVELS["NONE"] = 0] = "NONE";
    LOCK_LEVELS[LOCK_LEVELS["SOFT"] = 1] = "SOFT";
    LOCK_LEVELS[LOCK_LEVELS["HARD"] = 2] = "HARD";
    LOCK_LEVELS[LOCK_LEVELS["FAILED"] = 3] = "FAILED";
    LOCK_LEVELS[LOCK_LEVELS["LOCKED"] = 4] = "LOCKED";
})(LOCK_LEVELS || (exports.LOCK_LEVELS = LOCK_LEVELS = {}));
exports.eventLinkTypes = ['root', 'scouts', 'schedule'];
exports.collegeLinkTypes = ['root', 'home', 'staff', 'roster', 'x', 'instagram'];
exports.conferenceLinkTypes = ['root', 'x', 'instagram'];
exports.allLinkTypes = exports.eventLinkTypes.concat(exports.collegeLinkTypes);
var ERcrtScrapingErrors;
(function (ERcrtScrapingErrors) {
    // ROOT_URL= 0,
    ERcrtScrapingErrors[ERcrtScrapingErrors["SPORT_URL"] = 1] = "SPORT_URL";
    ERcrtScrapingErrors[ERcrtScrapingErrors["STAFF_URL"] = 2] = "STAFF_URL";
    ERcrtScrapingErrors[ERcrtScrapingErrors["SCHEDULE_URL"] = 3] = "SCHEDULE_URL";
    ERcrtScrapingErrors[ERcrtScrapingErrors["NO_IMAGE"] = 4] = "NO_IMAGE";
    ERcrtScrapingErrors[ERcrtScrapingErrors["NO_STAFF_IMAGES"] = 5] = "NO_STAFF_IMAGES";
    ERcrtScrapingErrors[ERcrtScrapingErrors["NO_STAFF_EMAILS"] = 6] = "NO_STAFF_EMAILS";
    ERcrtScrapingErrors[ERcrtScrapingErrors["NO_STAFF"] = 7] = "NO_STAFF";
    ERcrtScrapingErrors[ERcrtScrapingErrors["MISSING_URL"] = 8] = "MISSING_URL";
    ERcrtScrapingErrors[ERcrtScrapingErrors["SCHEDULE_TEST_FAIL"] = 9] = "SCHEDULE_TEST_FAIL";
    ERcrtScrapingErrors[ERcrtScrapingErrors["SCHEDULE_ROW_FAIL"] = 10] = "SCHEDULE_ROW_FAIL";
    ERcrtScrapingErrors[ERcrtScrapingErrors["SCHEDULE_NO_GAMES"] = 11] = "SCHEDULE_NO_GAMES";
    // SCHEDULE_DUPLICATE_OPPONENTS = 12,
    ERcrtScrapingErrors[ERcrtScrapingErrors["SCHEDULE_SEASON_ERRORS"] = 13] = "SCHEDULE_SEASON_ERRORS";
    ERcrtScrapingErrors[ERcrtScrapingErrors["ADDRESS_ISSUE"] = 14] = "ADDRESS_ISSUE";
    ERcrtScrapingErrors[ERcrtScrapingErrors["SCHEDULE_MISSING_OPPONENT"] = 15] = "SCHEDULE_MISSING_OPPONENT";
    ERcrtScrapingErrors[ERcrtScrapingErrors["NO_DIVISION"] = 16] = "NO_DIVISION";
    ERcrtScrapingErrors[ERcrtScrapingErrors["NO_SUBDIVISION"] = 17] = "NO_SUBDIVISION";
    ERcrtScrapingErrors[ERcrtScrapingErrors["ROSTER_TEST_FAIL"] = 18] = "ROSTER_TEST_FAIL";
    ERcrtScrapingErrors[ERcrtScrapingErrors["STAFF_SCRAPE_FAIL"] = 20] = "STAFF_SCRAPE_FAIL";
})(ERcrtScrapingErrors || (exports.ERcrtScrapingErrors = ERcrtScrapingErrors = {}));
var EMetricCategories;
(function (EMetricCategories) {
    EMetricCategories["ROSTER"] = "Roster";
})(EMetricCategories || (exports.EMetricCategories = EMetricCategories = {}));
var ERosterMetricMap;
(function (ERosterMetricMap) {
    ERosterMetricMap["TOTAL"] = "Total";
    ERosterMetricMap["INTERNATIONAL"] = "International";
    ERosterMetricMap["RETURNING"] = "Returning";
    ERosterMetricMap["NEW"] = "New";
    ERosterMetricMap["AMERICAN"] = "American";
    ERosterMetricMap["STATES"] = "States";
    ERosterMetricMap["TRANSFER_IN"] = "Transfer In";
    ERosterMetricMap["TRANSFER_OUT"] = "Transfer Out";
    ERosterMetricMap["GRAD"] = "Grad";
    ERosterMetricMap["OTHER"] = "Other";
    ERosterMetricMap["CLASS"] = "Class";
    ERosterMetricMap["COUNTRIES"] = "Countries";
})(ERosterMetricMap || (exports.ERosterMetricMap = ERosterMetricMap = {}));
var ERcrtClassYears;
(function (ERcrtClassYears) {
    ERcrtClassYears["FRESHMAN"] = "fr";
    ERcrtClassYears["SOPHOMORE"] = "so";
    ERcrtClassYears["JUNIOR"] = "jr";
    ERcrtClassYears["SENIOR"] = "sr";
    ERcrtClassYears["SENIOR_PLUS"] = "sr+";
    ERcrtClassYears["GRAD"] = "gr";
})(ERcrtClassYears || (exports.ERcrtClassYears = ERcrtClassYears = {}));
exports.ERcrtScrapingErrors_MAP = {
    // 0: 'No Root Url',
    1: 'No Sport Url',
    2: 'No Staff Url',
    3: 'No Schedule Url',
    4: 'No main image',
    5: 'No staff images',
    6: 'No staff emails.',
    7: 'No staff found.',
    // 8: 'Missing a url',
    // 9: 'Schedule year test failed',
    10: 'No schedule rows found',
    11: 'No games found',
    12: 'Duplicate opponents found',
    13: 'Season has errors',
    14: 'Bad or no address',
    15: 'Schedule with missing opponent(s)',
    16: 'No division set',
    17: 'No NCAA sub-division set'
};
exports.COLLEGE_GENDERS = [
    {
        label: 'Men',
        value: 'men'
    },
    {
        label: 'Women',
        value: 'women'
    }
];
var EScrapeStatus;
(function (EScrapeStatus) {
    EScrapeStatus["KNOWN_EMPTY"] = "Known Empty";
    EScrapeStatus["EDGE_CASE"] = "Edge";
    EScrapeStatus["INPUT_MANUALLY"] = "Html Input Manually";
})(EScrapeStatus || (exports.EScrapeStatus = EScrapeStatus = {}));
exports.supportedYears = [];
let next = new Date().getFullYear();
while (next >= 2013) {
    exports.supportedYears.push(next.toString());
    next--;
}
class College extends model_core_1.Base {
    title = '';
    alt_titles = [];
    links = [];
    sport = index_1.ERcrtSports.NONE;
    gender = null;
    season = null;
    image = null;
    staff = [];
    division = COLLEGE_DIVISIONS.NONE;
    subdivision = COLLEGE_SUBDIVISIONS.NONE;
    address = null;
    tz = '';
    errors = {};
    errorCount = 0;
    record = '';
    conf = null;
    seasons = new model_core_1.ChildArray();
    years = {};
    _m = ['title', 'image'];
    _s = ['title', 'alt_titles', 'staff', 'active', 'division', 'subdivision', 'conf', 'address', 'errors', 'image', 'gender', 'sport', 'record', 'errorCount'];
    get shortName() {
        return this.title.replace(/( *)(university of|university|community college|college)( *)/i, '');
    }
    constructor(data, olMap) {
        super('colleges', 14);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, College);
        exports.collegeLinkTypes.forEach(id => {
            if (!this.getLink(id)) {
                this.add('links', { id: id, url: '', lock: 0, error: ERcrtScrapingErrors.MISSING_URL });
            }
        });
    }
    getLink(id) {
        return this.links?.find(l => l.id === id);
    }
    // We need to know when the sport is 'in season' so we
    // know whether to trust the sports website's information
    // and update coaches at the proper time.  The number 7 in
    // this method is specific to soccer and will need to be customized
    // by sport.
    isCurrentYear(yr) {
        let now = new Date();
        let thisYr = Number(yr) === now.getFullYear();
        let lastYr = Number(yr) === (now.getFullYear() - 1);
        if (this.season === 'f'
            && ((now.getMonth() >= 7 && thisYr)
                || (now.getMonth() < 7 && lastYr))) {
            return true;
        }
        else if (this.season === 's'
            && ((now.getMonth() < 7 && thisYr)
                || (now.getMonth() >= 7 && lastYr))) {
            return true;
        }
        return false;
    }
    getStaffWithImages() {
        return this.staff?.reduce((withImg, s) => {
            if (s.image?.src) {
                withImg.push(s);
            }
            return withImg;
        }, []) || [];
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        if (!opts.properties) {
            opts.properties = ['seasons', 'conf'];
        }
        await super.loadAll(opts, stack, p);
    }
    setErrorStates() {
        if (this.errors) {
            this.errors[ERcrtScrapingErrors.NO_STAFF] = this.staff?.length ? 0 : 1;
            this.errors[ERcrtScrapingErrors.NO_STAFF_EMAILS] = this.staff?.find(s => s.email) ? 0 : 1;
            this.errors[ERcrtScrapingErrors.SPORT_URL] = this.getLink('home')?.url ? 0 : 1;
            this.errors[ERcrtScrapingErrors.STAFF_URL] = this.getLink('staff')?.url ? 0 : 1;
            this.errors[ERcrtScrapingErrors.SCHEDULE_URL] = this.getLink('schedule')?.url ? 0 : 1;
            this.errors[ERcrtScrapingErrors.NO_IMAGE] = this.image?.src ? 0 : 1;
            this.errors[ERcrtScrapingErrors.ADDRESS_ISSUE] = 0;
            this.errors[ERcrtScrapingErrors.SCHEDULE_NO_GAMES] = 0;
            this.errors[ERcrtScrapingErrors.SCHEDULE_SEASON_ERRORS] = 0;
            this.errors[ERcrtScrapingErrors.NO_DIVISION] = (this.division) ? 0 : 1;
            this.errors[ERcrtScrapingErrors.NO_SUBDIVISION] = (!this.subdivision && this.division === COLLEGE_DIVISIONS.NCAA) ? 1 : 0;
            if (!this.address?.latitude || !this.address?.longitude) {
                this.errors[ERcrtScrapingErrors.ADDRESS_ISSUE] = 1;
            }
        }
    }
    toJSON() {
        let r = super.toJSON();
        r.errorCount = Object.keys(this.errors || {})?.reduce((n, key) => {
            if (this.errors[key]) {
                n++;
            }
            return n;
        }, 0);
        return r;
    }
    cleanStaff() {
        // If we scraped data from a coaches-only page (not a roster page)
        // then we won't cull it off even if there's no email.  There are actually
        // a number of msoc/coaches/index pages that have a coach with name only.
        if (this.staff?.length) {
            for (let i = this.staff?.length - 1; i >= 0; i--) {
                if (!this.staff[i].name) {
                    this.staff.splice(i, 1);
                }
            }
        }
    }
    cleanStaffTitle(title) {
        if (title) {
            let re = new RegExp(`${this.gender}'s`, 'i');
            title = title.replace(re, '');
            re = new RegExp(this.sport, 'i');
            title = title.replace(re, '');
            title = title.trimStart();
        }
        return title;
    }
    save(parent) {
        if (!this.id) {
            throw `Cannot save college without id  (${this.title}).`;
        }
        if (!this.getLink('root')?.url && this.id !== 'not-found') {
            throw `Cannot save college without root url (${this.title}-${this.id}).`;
        }
        // Remove any empty staff items
        this.cleanStaff();
        return super.save(parent);
    }
    async toSearchJSON(opts) {
        let r = await super.toSearchJSON(opts);
        if (this.address?.latitude && this.address?.longitude) {
            r._geoloc = {
                lat: Number(this.address.latitude),
                lng: Number(this.address.longitude)
            };
        }
        return r;
    }
}
exports.College = College;
class Conference extends model_core_1.Base {
    name = '';
    long_name = '';
    links = [];
    sports = [];
    image = null;
    division = COLLEGE_DIVISIONS.NONE;
    subdivision = COLLEGE_SUBDIVISIONS.NONE;
    _m = ['name', 'long_name'];
    _s = ['name', 'long_name', 'division', 'subdivision', 'image', 'links', 'sports'];
    constructor(data, olMap) {
        super('conferences', 13);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, College);
        exports.conferenceLinkTypes.forEach(id => {
            if (!this.getLink(id)) {
                this.add('links', { id: id, url: '', lock: 0, error: ERcrtScrapingErrors.MISSING_URL });
            }
        });
    }
    getLink(id) {
        return this.links?.find(l => l.id === id);
    }
}
exports.Conference = Conference;
class CollegeRef extends model_core_1.Base {
    college = null;
    ref = null;
    notes = '';
    questionnaire = false;
    rating = { weight: 0 };
    eRef_ids = [];
    eRefs = [];
    counts = { comments: 0, emails: 0 };
    results_views = 0;
    results_card = 0;
    results_pviews = 0;
    results_plays = 0;
    results_replies = 0;
    _m = ['ref'];
    constructor(data, olMap) {
        super('college_refs', 14);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, CollegeRef);
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        if (this.ref) {
            this.college = new College(opts.getDoc ? await opts.getDoc(this.ref) : await this.ref.get(), index_1.olm);
        }
        await super.loadAll(opts, stack, p);
    }
    toJSON() {
        let r = super.toJSON();
        r.ref = this.college?._docRef || this.ref;
        r.eRef_ids = this.eRefs.map(e => e.id);
        delete r.college;
        return r;
    }
    calc(factors) {
        if (factors?.length && this.rating?.items?.length) {
            this.rating.items.forEach(item => {
                let factor = factors.find(f => f.label.toLowerCase() === item.label.toLowerCase());
                if (factor?.importance) {
                    item.weight = Number(factor.importance || 0) * Number(item.rating || 0);
                }
                else {
                    item.weight = 0;
                }
            });
            this.rating.weight = this.rating.items.reduce((total, item) => {
                total += item.weight;
                return total;
            }, 0);
        }
    }
    async save(parent, setDoc) {
        if (!this.college?._docRef && !this.ref) {
            throw `Cannot save College reference until it has a docRef!`;
        }
        else {
            this.id = this.id || this.college?.id;
            this.active = (this.active !== null) ? this.active : true;
            this.last_date = this.last_date || Date.now();
            this.ref = this.college?._docRef || this.ref;
        }
        return super.save(parent, setDoc);
    }
}
exports.CollegeRef = CollegeRef;
class RcrtStaffChange extends model_core_1.Base {
    additions = [];
    removals = [];
    ref = null;
    college = null;
    correct = 0;
    incorrect = 0;
    _m = ['ref'];
    constructor(data, olMap) {
        super('staff_changes', 14);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, CollegeRef);
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        if (this.ref) {
            this.college = new College(opts.getDoc ? await opts.getDoc(this.ref) : await this.ref.get(), index_1.olm);
        }
        await super.loadAll(opts, stack, p);
    }
}
exports.RcrtStaffChange = RcrtStaffChange;
class CollegeSeason extends model_core_1.Base {
    year = '';
    wins = null;
    losses = null;
    ties = null;
    errors = [];
    season_games = new model_core_1.ChildArray();
    link = { id: 'schedule', url: '' };
    get record() {
        if (this._exists) {
            return `${this.wins || '0'}-${this.losses || '0'}-${this.ties || '0'}`;
        }
        else {
            return 'N/A';
        }
    }
    constructor(data, olMap) {
        super('seasons', 14);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, CollegeSeason);
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        await super.loadAll(opts, stack, p);
        if (this.season_games?.length) {
            this.season_games.sort((a, b) => (a.date < b.date) ? -1 : 1);
        }
    }
    toJSON() {
        let r = super.toJSON();
        delete r.season_games;
        return r;
    }
    save(parent) {
        if (!this.id) {
            throw `Cannot save event without id.`;
        }
        this.last_date = Date.now();
        return super.save(parent);
    }
}
exports.CollegeSeason = CollegeSeason;
class CollegeSeasonGame extends model_core_1.Base {
    time = [];
    result = null;
    resultNote = '';
    points_for = null;
    points_against = null;
    location = null;
    ref = null;
    opponent = null;
    opponent_title = '';
    opponent_reserve = false;
    // recapUrl?: string = '';
    notes = '';
    exhibition = false;
    toString() {
        return `${this.location === 'h' ? 'vs ' : '@ '} ${this.opponent.title}: ${new Date(...this.time).toString()}: ${this.result || ''} ${this.points_for || ''}-${this.points_against || ''}`;
    }
    getDate() {
        let d = new Date(...this.time);
        if (this.time?.length && this.time[3] !== undefined) {
            return (0, date_fns_1.format)(d, 'eeee, MMM d h:mm a ');
        }
        else {
            return (0, date_fns_1.format)(d, 'eeee, MMM d');
        }
    }
    hasTime() {
        return !!this.time[3];
    }
    constructor(data, olMap) {
        super('season_games', 6);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, CollegeSeasonGame);
    }
    async loadAll(opts, stack, p) {
        opts = opts || {};
        opts.olm = opts.olm || index_1.olm;
        if (this.ref) {
            this.opponent = new College(opts.getDoc ? await opts.getDoc(this.ref) : await this.ref.get(), index_1.olm);
        }
        await super.loadAll(opts, stack, p);
    }
    toJSON() {
        let r = super.toJSON();
        delete r.opponent;
        return r;
    }
    async save(parent, setDoc) {
        if (!this.opponent?._docRef && !this.ref && this.opponent?.id !== 'not-found') {
            throw `Cannot save College reference until it has a docRef!`;
        }
        else {
            this.last_date = Date.now();
            this.ref = this.opponent?._docRef || this.ref;
        }
        return super.save(parent, setDoc);
    }
}
exports.CollegeSeasonGame = CollegeSeasonGame;
class Player extends model_core_1.Base {
    image = {};
    name = '';
    positions = [];
    schools = [];
    yrs = [];
    yrSchools = [];
    previous = '';
    city = '';
    state = '';
    country = '';
    years = {};
    bio = {};
    gender = null;
    sport = index_1.ERcrtSports.NONE;
    socials = {};
    stats = {};
    non_dups = [];
    dup = false;
    _s = ['name', 'state', 'city', 'country', 'schools', 'positions', 'years', 'dup', 'non_dups', 'gender', 'sport', 'yrs', 'stats', 'image'];
    constructor(data, olMap, type, idLen) {
        super(type || 'players', idLen || 36);
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, Player);
    }
    async save(parent, setDoc) {
        if (!this.id) {
            throw `Cannot save!  Player record requires gender, sport, name, city, state & country values. (${this.name}): ${this.gender || 'NO GENDER'},${this.sport || 'NO SPORT'},${this.city || 'NO CITY'},${this.state},${this.country || 'NO COUNTRY'}`;
        }
        if (!this.name) {
            throw `Cannot save! Name must be set!`;
        }
        else {
            // One word names not allowed!
            if (this.name.split(' ').length <= 1) {
                throw `Cannot save! Full name must be set! "${this.name}" looks invalid.`;
            }
        }
        return super.save(parent, setDoc);
    }
    setID() {
        if (this.sport && this.gender && this.name) {
            // Split name into parts and substring the first name (example: Samantha McKibben at Depaul became Sam McKibben at WashU);
            let nameParts = this.name.split(' ');
            let name = nameParts.map((n, x) => {
                if (nameParts[x + 1]) {
                    if (n.length >= 3) {
                        return n.substring(0, 3);
                    }
                    else {
                        return n;
                    }
                }
                else {
                    return n;
                }
            }).join(' ');
            let parts = [this.gender.substring(0, 1), this.sport, name];
            this.id = parts.reduce((id, p) => {
                if (p) {
                    p = p.toLowerCase().replace(/ /g, '_').replace(/\//, '--');
                    id.push(p);
                }
                return id;
            }, []).join('-') + '-' + (0, model_core_1.getSID)(8);
        }
    }
    toJSON() {
        // To make querying easier, build arrays of years played, school ids attended, and yr+schoolId string.
        this.schools = [];
        this.yrSchools = [];
        this.yrs = Object.keys(this.years);
        this.yrs.forEach(yr => {
            let yrSchool = `${yr}-${this.years[yr].id}`;
            this.add('yrSchools', yrSchool);
            if (this.years[yr] && this.years[yr].id) {
                this.add('schools', this.years[yr].id);
            }
        });
        this.stats.y = this.yrs.length;
        this.stats.s = this.schools.length;
        return super.toJSON();
    }
    getRosterAnalysis(c, yr, leaving) {
        let r = {};
        let prev = yr - 1;
        let prev2 = yr - 2;
        if (!leaving) {
            r[ERosterMetricMap.TOTAL] = 1;
            r[ERosterMetricMap.RETURNING] = (this.yrSchools.find(yrId => yrId === `${prev}-${c.id}` || yrId === `${prev2}-${c.id}`)) ? 1 : 0;
            r[ERosterMetricMap.TRANSFER_IN] = (this.years && this.years[prev] && this.years[prev].id !== c.id) ? 1 : 0;
            r[ERosterMetricMap.NEW] = (!r[ERosterMetricMap.RETURNING] && !r[ERosterMetricMap.TRANSFER_IN]) ? 1 : 0;
            r[ERosterMetricMap.AMERICAN] = (this.country === 'US') ? 1 : 0;
            r[ERosterMetricMap.INTERNATIONAL] = (this.country && this.country !== 'US') ? 1 : 0;
            r[ERosterMetricMap.COUNTRIES] = this.country || '';
            r[ERosterMetricMap.STATES] = (this.country === 'US') ? this.state || '' : '';
            r[ERosterMetricMap.CLASS] = (this.years && this.years[yr] && this.years[yr].class) ? this.years[yr].class : '';
        }
        else {
            r[ERosterMetricMap.TRANSFER_OUT] = (this.years && this.years[yr] && this.years[yr].id !== c.id) ? 1 : 0;
            r[ERosterMetricMap.GRAD] = (!r[ERosterMetricMap.TRANSFER_OUT] && this.years && this.years[prev] && this.years[prev].class === 'sr') ? 1 : 0;
            r[ERosterMetricMap.OTHER] = (!r[ERosterMetricMap.GRAD] && !r[ERosterMetricMap.TRANSFER_OUT]) ? 1 : 0;
        }
        return r;
    }
}
exports.Player = Player;
class Coach extends Player {
    email = '';
    phone = '';
    title = '';
    url = '';
    other = [];
    alma_mater = null;
    dup = false;
    non_dups = [];
    stats = {};
    ref = null;
    _s = ['name', 'state', 'city', 'country', 'schools', 'title', 'years', 'dup', 'non_dups', 'gender', 'sport', 'yrs', 'stats', 'other', 'alma_mater', 'image'];
    constructor(data, olMap) {
        super(data, olMap || index_1.olm, 'coaches');
        (0, model_core_1.setObjectProperties)(this, data, olMap || index_1.olm, Coach);
    }
    toStaffJSON() {
        this.setLatest();
        return {
            name: this.name,
            email: this.email,
            title: this.title,
            phone: this.phone,
            url: this.url,
            image: this.image
        };
    }
    toJSON() {
        this.setLatest();
        return super.toJSON();
    }
    setLatest() {
        let latest = Object.keys(this.years || {}).map(yr => Number(yr)).sort().at(-1);
        if (latest && this.years[latest.toString()]) {
            ['title', 'phone', 'email', 'image'].forEach(p => {
                if (this.years[latest.toString()][p]) {
                    this[p] = this.years[latest.toString()][p];
                }
            });
        }
    }
    isCoach() {
        this.setLatest();
        // Handle some edge cases.
        if (this.title?.match(/(Director of Men's Soccer|Director of Women's Soccer)$/i)) {
            return true;
        }
        else if (this.title?.match(/^(Director of Men's Soccer|Director of Women's Soccer|Director of Soccer|Women's Soccer|Assistant Soccer|Men's Soccer|Volunteer Assistant|Graduate Assistant|Grad Assistant)/i)) {
            return true;
        }
        else if (this.title?.match(/(performance|operations|conditioning|strength|trainer)/i)) {
            return false;
        }
        else if (!this.title?.match(/coach/i)) {
            return false;
        }
        else if (this.name?.match(/tba|tbd/i)) {
            return false;
        }
        else if (!this.title?.match(/coach/i) && this.title?.match(/(graduate|performance|operations|conditioning|trainer)/i)) {
            return false;
        }
        return true;
    }
    setID() {
        // Ignore non-coaches and grad assistants.
        if (this.isCoach()) {
            return super.setID();
        }
    }
    save(p) {
        if (!this.gender || !this.sport) {
            throw `Cannot save! Must set gender and sport!`;
        }
        return super.save(p);
    }
}
exports.Coach = Coach;
index_1.olm.colleges = (ref, map) => {
    return new College(ref, map);
};
index_1.olm.conferences = (ref, map) => {
    return new Conference(ref, map);
};
index_1.olm.college_refs = (ref, map) => {
    return new CollegeRef(ref, map);
};
index_1.olm.staff_changes = (ref, map) => {
    return new RcrtStaffChange(ref, map);
};
index_1.olm.seasons = (ref, map) => {
    return new CollegeSeason(ref, map);
};
index_1.olm.season_games = (ref, map) => {
    return new CollegeSeasonGame(ref, map);
};
index_1.olm.players = (ref, map) => {
    return new Player(ref, map);
};
index_1.olm.coaches = (ref, map) => {
    return new Coach(ref, map);
};
